export default (context) => {
  if (!context.$apolloHelpers.getToken()) {
    context.redirect('/')
  }
}
